<template>
  <h1>No se encuentra esta pagina</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>